<template>
  <div v-if="authenticated" class="app-wrapper" @dragover.prevent @drop.prevent :style="brandColours">
    <header-phone/>
    <header-logo/>
    <thread-chat-drawer/>

    <div class="dashboard">
      <div class="dashboard-container">
        <navigation class="dashboard-nav" ref="navigation"/>

        <!--  the bit here for overflow hidden is a workaround for the dropdown on the interests page, eventually we should remove overflow: hidden from here entirely      -->
        <div class="dashboard-main" :style="$route.name !== 'talent.profile.show.interests' && $route.name !== 'profile.show.interests' && $route.name !== 'profile.show.career' && $route.name !== 'talent.profile.show.career' ? 'overflow: hidden' : null" v-show="notLoading">
          <router-view/>
        </div>
      </div>
    </div>

    <div id="footer" class="footer">
      <component :is=" $vlastMode ? 'vlast-footer' : 'marketplace-footer'" ></component>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import cssVars from 'css-vars-ponyfill'
import 'assets/sass/app.scss'
import Pusher from 'utils/pusher'
import { findIndex } from 'lodash'
import HeaderLogo from './HeaderLogo'
import Navigation from './Navigation'
import HeaderPhone from './HeaderPhone'
import { notify, auth } from 'utils'
import { mapState, mapActions } from 'vuex'
import ThreadChatDrawer from '../components/message/ThreadChatDrawer'
import VlastLogoMonogram from '../components/icons/VlastLogoMonogram'
import VlastFooter from '../components/globals/VlastFooter'

import MarketplaceFooter from '../components/globals/MarketplaceFooter'
import Vue from 'vue'

const tinycolor = require('tinycolor2')

export default {
  components: {
    VlastLogoMonogram,
    HeaderPhone,
    HeaderLogo,
    Navigation,
    ThreadChatDrawer,
    VlastFooter,
    MarketplaceFooter
  },

  data () {
    return {
      authenticated: false
    }
  },

  computed: {
    ...mapState('app', ['loading']),
    ...mapState('clientConfig', ['client_config']),
    ...mapState('message', ['thread', 'threads']),

    notLoading () {
      return !this.loading
    },

    documentActive () {
      return document.visibilityState === 'visible'
    },

    brandColours () {
      return {
        '--brand-primary': this.client_config.colours.brand_primary,
        '--brand-primary-light': tinycolor ? tinycolor(this.client_config.colours.brand_primary).lighten(10).toString() : null,
        '--brand-primary-lightest': tinycolor ? tinycolor(this.client_config.colours.brand_primary).lighten(25).toString() : null,
        '--brand-primary-dark': tinycolor ? tinycolor(this.client_config.colours.brand_primary).darken(10).toString() : null,
        '--brand-primary-darkest': tinycolor ? tinycolor(this.client_config.colours.brand_primary).darken(25).toString() : null,
        '--brand-secondary': this.client_config.colours.brand_info,
        '--brand-secondary-light': tinycolor ? tinycolor(this.client_config.colours.brand_info).lighten(10).toString() : null,
        '--brand-secondary-lightest': tinycolor ? tinycolor(this.client_config.colours.brand_info).lighten(25).toString() : null,
        '--brand-secondary-dark': tinycolor ? tinycolor(this.client_config.colours.brand_info).darken(10).toString() : null,
        '--brand-secondary-darkest': tinycolor ? tinycolor(this.client_config.colours.brand_info).darken(25).toString() : null,
        '--brand-info': this.client_config.colours.brand_info,
        '--brand-info-light': tinycolor ? tinycolor(this.client_config.colours.brand_info).lighten(10).toString() : null,
        '--brand-info-lightest': tinycolor ? tinycolor(this.client_config.colours.brand_info).lighten(25).toString() : null,
        '--brand-info-dark': tinycolor ? tinycolor(this.client_config.colours.brand_info).darken(10).toString() : null,
        '--brand-info-darkest': tinycolor ? tinycolor(this.client_config.colours.brand_info).darken(25).toString() : null,
        '--brand-vlast': this.client_config.colours.brand_vlast,
        '--brand-vlast-light': tinycolor ? tinycolor(this.client_config.colours.brand_vlast).lighten(10).toString() : null,
        '--brand-vlast-lightest': tinycolor ? tinycolor(this.client_config.colours.brand_vlast).lighten(25).toString() : null,
        '--brand-vlast-dark': tinycolor ? tinycolor(this.client_config.colours.brand_vlast).darken(10).toString() : null,
        '--brand-vlast-darkest': tinycolor ? tinycolor(this.client_config.colours.brand_vlast).darken(25).toString() : null,
        '--brand-vlast-text': this.client_config.colours.brand_vlast_text,
        '--brand-vlast-text-light': tinycolor ? tinycolor(this.client_config.colours.brand_vlast_text).lighten(10).toString() : null,
        '--brand-vlast-text-lightest': tinycolor ? tinycolor(this.client_config.colours.brand_vlast_text).lighten(25).toString() : null,
        '--brand-vlast-text-dark': tinycolor ? tinycolor(this.client_config.colours.brand_vlast_text).darken(10).toString() : null,
        '--brand-vlast-text-darkest': tinycolor ? tinycolor(this.client_config.colours.brand_vlast_text).darken(25).toString() : null,
        '--brand-text': this.client_config.colours.brand_text,
        '--brand-text-light': tinycolor ? tinycolor(this.client_config.colours.brand_text).lighten(10).toString() : null,
        '--brand-text-lightest': tinycolor ? tinycolor(this.client_config.colours.brand_text).lighten(25).toString() : null,
        '--brand-text-dark': tinycolor ? tinycolor(this.client_config.colours.brand_text).darken(10).toString() : null,
        '--brand-text-darkest': tinycolor ? tinycolor(this.client_config.colours.brand_text).darken(25).toString() : null,
        '--brand-success': '#5cb85c',
        '--brand-success-light': tinycolor ? tinycolor('#5cb85c').lighten(10).toString() : null,
        '--brand-success-lightest': tinycolor ? tinycolor('#5cb85c').lighten(25).toString() : null,
        '--brand-success-dark': tinycolor ? tinycolor('#5cb85c').darken(10).toString() : null,
        '--brand-success-dark-transparent': tinycolor ? tinycolor('#5cb85c22').darken(10).toString() : null,
        '--brand-success-darkest': tinycolor ? tinycolor('#5cb85c').darken(25).toString() : null,
        '--brand-danger': '#d9534f',
        '--brand-danger-light': tinycolor ? tinycolor('#d9534f').lighten(10).toString() : null,
        '--brand-danger-lightest': tinycolor ? tinycolor('#d9534f').lighten(25).toString() : null,
        '--brand-danger-dark': tinycolor ? tinycolor('#d9534f').darken(10).toString() : null,
        '--brand-danger-darkest': tinycolor ? tinycolor('#d9534f').darken(25).toString() : null,
        '--brand-warning': '#f0ad4e',
        '--brand-warning-light': tinycolor ? tinycolor('#f0ad4e').lighten(10).toString() : null,
        '--brand-warning-lightest': tinycolor ? tinycolor('#f0ad4e').lighten(25).toString() : null,
        '--brand-warning-dark': tinycolor ? tinycolor('#f0ad4e').darken(10).toString() : null,
        '--brand-warning-darkest': tinycolor ? tinycolor('#f0ad4e').darken(25).toString() : null,
        '--brand-default': '#ccc',
        '--brand-default-light': tinycolor ? tinycolor('#ccc').lighten(10).toString() : null,
        '--brand-default-lightest': tinycolor ? tinycolor('#ccc').lighten(25).toString() : null,
        '--brand-default-dark': tinycolor ? tinycolor('#ccc').darken(10).toString() : null,
        '--brand-default-darkest': tinycolor ? tinycolor('#ccc').darken(25).toString() : null
      }
    }
  },

  mounted () {
    $(window).on('resize', this.fixContainerHeightIfRequired)

    this.fixContainerHeightIfRequired()

    this.initializeHelpHero()

    this.getVettingCount()
  },

  created () {
    auth.attemptViaToken()
      .then((response) => {
        cssVars({
          variables: this.brandColours
        })

        const colorMixin = {
          computed: {
            $brandPrimary () {
              return this.client_config.colours.brand_primary
            }
          }
        }

        try {
          const favicon = document.getElementById('favicon')
          favicon.setAttribute('href', '/static/' + this.client_config.tenant_details.client_name.toLowerCase() + '/favicon.ico')
        } catch (error) {
        }

        Vue.mixin(colorMixin)

        if (response && !response.status && response.response && response.response.status === 401) {
          this.$router.push({ name: 'login', query: { redirect: this.$router.currentRoute.path } })
        } else {
          this.authenticated = true
          Pusher.connect()

          if (!this.$userIsIntern) {
            let channelName = `${this.client_config.slug}.chat.${this.$user.id}`
            let eventName = 'MessageSent'
            if (this.$userIsAdmin) {
              this.getSettings()
            }

            if (this.$userIsAdmin || this.$user.role === 'sales') {
              channelName = this.client_config.slug + '.chat.admin'
              eventName = 'MessageSentAdmin'
              this.$echo.private(`${this.client_config.slug}.chat.${this.$user.id}`)
            }

            this.$echo.private(channelName)
              .listen(eventName, (payload) => {
                if (payload.message.user.id !== this.$user.id) {
                  this.addMessage(payload).then(() => {
                    if (this.thread && this.thread.id === payload.message.thread_id) {
                      this.updateParticipantsUnreads({
                        messageId: payload.message.id,
                        participantId: payload.message.user_id,
                        threadId: payload.message.thread_id
                      })
                      this.markAllMessagesRead({
                        threadId: this.thread.id,
                        messageId: payload.message.id,
                        userId: this.$user.id,
                        count: 0,
                        tenantSlug: this.client_config.slug
                      })
                    }
                  })
                  this.addMessageDashboard({payload: payload, userId: this.$user.id})
                  this.addMessageBooking({payload: payload, userId: this.$user.id})
                  this.incrementUnreadCount(payload)
                  let unreadCount = 0
                  if (payload.message.unread_count) {
                    unreadCount = payload.message.unread_count
                  } else {
                    let index = findIndex(this.threads, current => current.id === payload.message.thread_id)
                    if (index !== -1) {
                      unreadCount = this.threads[index].unread_count
                    }
                  }

                  if (this.$userIsAdmin && !this.documentActive && this.threadPinned(payload.message.thread_id)) {
                    var notification = new Notification(
                      payload.message.user.name + ': ' + payload.message.text,
                      {
                        icon: 'https://pickstar.pro/favicon.ico',
                        badge: 'https://pickstar.pro/favicon.ico',
                        image: 'https://pickstar.pro/favicon.ico'
                      })
                  }

                  if (this.$userIsAdmin && (payload.message.text.includes('Emma') || payload.message.text.includes('Jess'))) {
                    // todo - I think this should eventually be abstracted out to user defined keywords that they want to be notified about
                    if (!this.documentActive) {
                      var notification2 = new Notification(
                        'A user has mentioned an admin\'s name in a message',
                        {
                          icon: 'https://pickstar.pro/favicon.ico',
                          body: payload.message.user.name + ': ' + payload.message.text,
                          badge: 'https://pickstar.pro/favicon.ico',
                          image: 'https://pickstar.pro/favicon.ico'
                        })
                    } else {
                      notify.messageNotif('A user has mentioned an admin\'s name in a message. -' + payload.message.user.name + ': ' + payload.message.text, payload.message.thread_id, unreadCount, this.client_config.slug)
                    }
                  }
                  if (((this.thread && this.thread.id !== payload.message.thread_id) || !this.thread)) {
                    // todo - something is going wrong down the track here and we need to track it back so that we can actually execute code after this
                    if (!this.$userIsAdmin || (this.threadPinned(payload.message.thread_id) && this.$userIsAdmin)) {
                      notify.messageNotif(payload.message.user.name + ': ' + payload.message.text, payload.message.thread_id, payload.message.id, this.$user.id, unreadCount, this.client_config.slug)
                    }
                  }
                }
              })
            this.$echo.private(channelName)
              .notification((notification) => {
                this.handleNotifications(notification)
              })
          }
        }
      }).catch((error) => {
      // TODO: Log this error somewhere as it might be important as to why authentication failed.
        console.warn(error)

        auth.redirectOnTokenExpired(to)
      })
  },

  beforeDestroy () {
    if (this.$userIsAdmin) {
      this.$echo.leave(this.client_config.slug + '.chat.admin')
    }
    this.$echo.leave(`${this.client_config.slug}.chat.${this.$user.id}`)
  },

  methods: {
    ...mapActions('settings', ['getSettings']),
    ...mapActions('message', ['addMessage', 'incrementUnreadCount', 'updateParticipantsUnreads', 'markAllMessagesRead']),
    ...mapActions('booking', ['addMessageBooking']),
    ...mapActions('booking/request/vetting', ['getVettingCount']),
    ...mapActions('dashboard', ['addMessageDashboard']),
    ...mapActions('notifications', ['handleNotifications']),

    getPhone (contactNumber) {
      return `tel:${contactNumber}`
    },

    publicUrl (path) {
      return `${process.env.PUBLIC_URL.replace('{tenant}', window.location.hostname.split('.')[0])}/${path}`
    },

    threadPinned (threadId) {
      return this.$user.pinned_threads.includes(threadId)
    },

    /**
     * On some screens the container is smaller than the navigation. We'll set a minimum height
     * on the container if that's the case.
     *
     * @return void
     */
    fixContainerHeightIfRequired () {
      if (this.$refs.navigation) {
        let container = $('.dashboard > .dashboard-container')
        let navigation = $(this.$refs.navigation.$el)

        if (container.height() < navigation.height()) {
          container.css('min-height', `${navigation.height() + 100}px`)
        }
      }
    },

    initializeHelpHero () {
      let w = window
      let d = document
      let a = process.env.HELP_HERO_KEY

      var h = w.HelpHero;
      if (!h) {
        if (window._iub && window._iub.csPurposes && window._iub.csPurposes.includes(3)) {
          var i = function () {
            i.q.push(arguments);
          }
          i.q = [];
          w.HelpHero = i;
          var s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = '//app.helphero.co/embed/' + a;
          var x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        }

        if (window.HelpHero) {
          window.HelpHero('identify', this.$user.id, {
            role: this.$user.role,
            name: this.$user.first_name
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../assets/sass/mixins/global-mixins';

  .app-wrapper {
    min-height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-items: stretch;
    flex-wrap: wrap;
    background: #f5f5f5;

    @media (max-width: 991px) {
      .pace-active + & {
        .dashboard {
          min-height: 60vh;
        }
      }
    }

    & > * {
      width: 100%;
    }
    .footer {
      margin-top: auto;
    }
  }
  .dashboard-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    @media (min-width: 991px) {
      flex-wrap: nowrap;
    }
  }
  .dashboard-nav {
    flex-shrink: 0;
    @include fp(
      $property: width,
      $min-value: 300,
      $max-value: 320,
      $start-breakpoint: 992,
      $end-breakpoint: 1920,
      $remove-start: true,
    );
    @media (max-width: 991px) {
      display: none;
      top: 90px;
      left: 0;
      right: 0;
      bottom: 0;
      height: calc(100% - 90px) !important;
      &.in {
        display: unset;
        position: static;
        overflow: hidden;
        z-index: 9999;
        width: 100%;
        max-width: unset;
        padding: 0;
        transform: none !important;
        box-shadow: none;
        .sidemenu {
          @media(max-width: 991px) {
            overflow-y: scroll;
            height: 75vh;
          }
          @media(min-width: 992px) {
            overflow-y: scroll;
            height: calc(100vh - 100px);
          }
        }
      }
    }
    @media (min-width: 992px) {
      display: flex;
      transform: translateX(0);
      top: 0;
      left: 0;
      max-height: 100vh;
      overflow: hidden;
      position: sticky;
    }
  }
  .dashboard-main {
    width: 100%;
    max-width: unset;
    @include fp(padding-bottom, 50, 120);
    .container-fluid {
      @include fp(
        $property: padding-left,
        $min-value: 24,
        $max-value: 96,
        $start-breakpoint: 320,
        $end-breakpoint: 992,
        $remove-end: true,
      );
      @include fp(
        $property: padding-right,
        $min-value: 24,
        $max-value: 96,
        $start-breakpoint: 320,
        $end-breakpoint: 992,
        $remove-end: true,
      );
      @include fp(
        $property: padding-left,
        $min-value: 48,
        $max-value: 96,
        $start-breakpoint: 992,
        $end-breakpoint: 1920,
        $remove-start: true,
      );
      @include fp(
        $property: padding-right,
        $min-value: 48,
        $max-value: 96,
        $start-breakpoint: 992,
        $end-breakpoint: 1920,
        $remove-start: true,
      );
    }
  }
</style>
